import { useContext } from "react";
import { NavContext } from "../NavContext";

/**
 * Gets the current navigation item context, whether it's in a dashboard or drawer.
 */
export function useNavContext(): "dashboard" | "drawer" | null {
  return useContext(NavContext) || null;
}
